<template >
  <div class="background">
    <v-container fluid class="beginning-wrapper">
      <v-row class="full-vh-height" align="center" justify="center">
        <v-card rounded class="content-card" style="position:relative">

          <v-container fluid class="full-height" v-if="!premessageScreen">
            <v-row class="full-height" justify="center">
              <v-col cols="12" class="options-col d-flex flex-column justify-center">
                <div class="text-content">
                  <v-row align="center" justify="center">
                    <p class="form-title">{{ title }}</p>
                  </v-row>
                  <v-row align="center" justify="center">
                    <p class="form-text">{{ text }}</p>
                  </v-row>
                </div>
                <v-row align="center" justify="center" class="options-center-row flex-grow-1">
                  <!-- Opción Imágenes -->
                  <v-col cols="12" sm="6" class="option-block">
                    <div class="option-inner text-center">
                      <v-img src="/img/reader/answeroption-images.png" class="option-img mx-auto" />
                      <v-btn
                        rounded
                        color="#F2865F"
                        dark
                        class="font-btn option-btn"
                        width="180px"
                        height="50px"
                        :loading="loadingButtonWords"
                        :disabled="loadingButtonImages"
                        @click="loadingButtonWords=true; getChallengeOptionsAndContinue(3)"
                      >
                        {{ $t('challenge.beginning_initial_challenge_question_option_images') }}
                      </v-btn>
                    </div>
                  </v-col>
                  <!-- Opción Palabras -->
                  <v-col cols="12" sm="6" class="option-block">
                    <div class="option-inner text-center">
                      <v-img src="/img/reader/answeroption-words.png" class="option-img mx-auto" />
                      <v-btn
                        rounded
                        color="#F2865F"
                        dark
                        class="font-btn option-btn"
                        width="180px"
                        height="50px"
                        :loading="loadingButtonImages"
                        :disabled="loadingButtonWords"
                        @click="loadingButtonImages=true; getChallengeOptionsAndContinue(1)"
                      >
                        {{ $t('challenge.beginning_initial_challenge_question_option_words') }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <v-img
          :src="require('../../../assets/img/bees/new_bee.png')"
          elevation="6"
          contain
          class="bee-one"
          v-if="premessageScreen"
          ></v-img>
          <v-container fluid class=" full-height" v-if="premessageScreen">
        <v-row align="center" justify="center" >
          <v-col cols="12" class="narrow-col">
                      <v-row align="center" justify="start" style="margin-top: 98px">
                          <p class="premessage-font-title">{{ title }}</p>
                      </v-row>
                      <v-row align="center" justify="start" class="text-left" style="margin-top: 45px">
                          <p class="premessage-font-text">
                          {{ $t('challenge.beginning_initial_challenge_premessage_text') }}
                          </p>
                      </v-row>
                      <v-row align="center" justify="center" style="margin-top: 45px">
                          <v-btn
                            rounded
                            color="#F2865F"
                            dark
                            class="mt-10 font-btn start-btn"
                            style="font-size: 15px"
                            width="300px"
                            height="50px"
                            @click="changeScreen()"
                          >
                            {{ $t('challenge.initial_text_button') }}
                          </v-btn>
                      </v-row>
                  </v-col>
              </v-row>
          </v-container>

        </v-card>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      modalActive: false,
      premessageScreen: true,
      loadingButtonWords: false,
      loadingButtonImages: false
    }
  },
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
    points: { type: [String, Number], required: true },
    beecoins: { type: [String, Number], required: true },
    getChallenge: { type: Function, required: true }
  },
  computed: {
    buttonSize() {
      return {
        width:
          this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
            ? '350px'
            : '18vw',
        height:
          this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
            ? '70px'
            : '3vw',
      }
    },
  },
  methods: {
    ...mapActions('challenge', ['setChallengeStage', 'setReadingTime', 'setReReadingTime']),
    changeScreen() {
        setTimeout(() => { this.premessageScreen = false }, 300);
    },
    async getChallengeOptionsAndContinue( optionTemplate ) {
        await this.getChallenge( optionTemplate );
        this.loadingButtonWords = false;
        this.loadingButtonImages = false;
    }
  },
}
</script>
<style scoped>
.background {
  background: linear-gradient(180deg, #A396DC 0%, #6857B3 100%);
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}

/* Ajustes específicos para móvil en background */
@media (max-width: 600px) {
  .background {
    min-height: calc(100vh - 60px)!important;
    height: calc(100vh - 60px)!important;
    width: 100vw!important;
    margin: 0!important;
    padding: 0!important;
    align-items: stretch!important;
    justify-content: stretch!important;
    display: block!important;
    overflow-x: hidden!important;
  }
  
  .full-vh-height {
    height: auto!important;
    min-height: auto!important;
  }
}

/* Tarjeta principal adaptable */
.content-card {
  border-radius: 20px !important;
  background: linear-gradient(146.1deg, #6d5bb0 0%, #b5a1eb 100%);
  border: 16px solid #5d5286;
  width: 100%;
  max-width: 620px;
  min-height: 520px;
  height: auto;
  padding: clamp(12px, 3vw, 32px) 0 32px;
  overflow: visible; /* Permitir overflow para móvil */
}

.full-height {
  height: 100%;
}

/* Títulos escalables */
.form-title {
  color: #ffffff;
  font-weight: 700;
  font-size: clamp(22px, 6vw, 40px);
  margin-top: clamp(16px, 6vh, 60px);
  text-align: center;
  line-height: 1.15;
  padding: 0 12px;
}

.form-text {
  color: #ffffff;
  font-size: clamp(14px, 4.2vw, 22px);
  margin-top: 10px;
  text-align: center;
  line-height: 1.3;
  padding: 0 16px;
}

/* Ajustes específicos para móvil */
@media (max-width: 600px) {
  .form-title {
    margin-top: 12px!important;
    margin-bottom: 8px!important;
    font-size: clamp(22px, 5.5vw, 28px)!important;
    padding: 0 16px!important;
  }
  
  .form-text {
    margin-top: 4px!important;
    margin-bottom: 12px!important;
    font-size: clamp(15px, 4vw, 18px)!important;
    padding: 0 20px!important;
  }
}

/* Imágenes de opciones fluidas */
.option-img {
  max-width: 170px;
  width: 100%;
  margin-top: 20px;
}

.button-text {
  width: 145px;
  height: 50px;
}

.font-btn {
  text-transform: initial;
  font-style: normal;
  font-weight: 600;
  font-size: clamp(13px, 3.5vw, 16px);
  line-height: 1.4;
}

.corner-number {
  position: absolute;
  left: -40px;
  top: -30px;
  width: 7vw;
  height: 8vw;
}

.corner-premessage-square {
  position: absolute;
  background-color: white;
  left: 0px;
  top: 0px;
  border-radius: 0 !important;
  box-shadow: none !important;
}

/* Abejas posicionadas de forma relativa para no romper layout en pantallas estrechas */
.bee-one {
  position: absolute;
  right: clamp(-10px, -4vw, -40px);
  top: clamp(-20px, -6vw, -50px);
  width: clamp(70px, 28vw, 130px);
  height: auto;
}

.bee-two {
  position: absolute;
  left: 65%;
  bottom: clamp(-20px, -5vw, -45px);
  transform: translateX(-50%);
  width: clamp(70px, 26vw, 130px);
  height: auto;
}

.premessage-font-title {
  font-style: normal;
  font-weight: 700;
  font-size: clamp(26px, 7vw, 40px);
  color: #FFFFFF;
  line-height: 1.15;
  text-align: left;
}

.premessage-font-text {
  font-style: normal;
  font-weight: 400;
  font-size: clamp(16px, 4.5vw, 22px);
  color: #FFFFFF;
  line-height: 1.35;
}

@media (min-width: 600px) {
  .form-title, .form-text { text-align: center; }
}
@media (min-width: 900px) {
  .content-card { min-height: 550px; }
}
@media (min-width: 1264px) {
  .content-card { max-width: 700px; }
}

/* Mejoras extra para pantallas muy pequeñas */
@media (max-width: 400px) {
  .content-card { 
    border-width: 12px;
    min-height: 100vh;
    border-radius: 0!important;
  }
  .font-btn { width: 100%!important; }
  .bee-two { left: 70%; }
}

/* Estilos específicos para móvil */
@media (max-width: 600px) {
  .content-card {
    min-height: calc(100vh - 60px)!important; /* Resta la altura del navbar inferior */
    max-height: calc(100vh - 60px)!important;
    height: calc(100vh - 60px)!important;
    border-radius: 0!important;
    max-width: 100vw!important;
    width: 100vw!important;
    margin: 0!important;
    overflow: hidden!important;
    position: relative!important;
    padding: 0!important;
    box-shadow: none!important;
  }
  
  .full-height {
    min-height: calc(100vh - 60px)!important;
    height: calc(100vh - 60px)!important;
    box-sizing: border-box!important;
    overflow: hidden!important;
  }
  
  .options-col {
    padding: 0!important;
  }
}

/* Centrado horizontal y vertical del contenedor principal */
.beginning-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0!important;
}

/* Padding lateral mobile - sin padding superior/inferior */
@media (max-width: 600px) {
  .beginning-wrapper { 
    padding: 0!important;
    margin: 0!important;
    min-height: calc(100vh - 60px)!important;
    height: calc(100vh - 60px)!important;
    width: 100vw!important;
    max-width: 100vw!important;
    align-items: stretch!important;
    justify-content: stretch!important;
    display: block!important;
  }
  
  .full-vh-height {
    min-height: calc(100vh - 60px)!important;
    height: calc(100vh - 60px)!important;
    margin: 0!important;
    padding: 0!important;
  }
}

/* Contenedor premessage (máx 500px) con padding adaptable */
.narrow-col {
  max-width: 500px;
  padding: clamp(24px,5vw,48px) clamp(24px,6vw,56px) clamp(40px,8vh,72px);
  margin: 0 auto;
  box-sizing: border-box;
}

/* Centrado del botón principal */
.start-btn { margin-left: 0!important; margin-right: 0!important; }

/* Contenedor de texto centrado */
.text-content {
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .text-content {
    margin-bottom: 8px;
    padding: 0 8px;
    box-sizing: border-box;
    flex-shrink: 0;
  }
  
  .options-col {
    height: calc(100vh - 92px)!important;
    display: flex!important;
    flex-direction: column!important;
    justify-content: space-evenly!important;
    padding: 0!important;
    box-sizing: border-box!important;
    max-width: 100%!important;
    overflow: hidden!important;
  }
}

/* Centrado de las opciones */
.options-center-row { 
  margin-top: 32px;
  align-items: center !important;
}

.option-block { 
  display: flex; 
  margin-bottom: 16px;
}

.option-inner { 
  width: 100%; 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content: center; 
  padding: 16px;
  min-height: 200px;
}

.option-img { 
  max-width: 160px;
  height: auto;
  flex-shrink: 0;
}

@media (max-width: 600px) { 
  .option-img { 
    max-width: 80px!important; 
    margin-bottom: 12px!important;
  }
  
  .options-center-row { 
    margin-top: 0px;
    flex-grow: 1;
    align-items: center !important;
    padding: 0!important;
    box-sizing: border-box!important;
    max-width: 100%!important;
  }
  
  .option-block {
    margin-bottom: 8px;
    max-width: 100%!important;
    box-sizing: border-box!important;
  }
  
  .option-inner {
    padding: 12px 16px;
    min-height: 120px;
    justify-content: center;
    max-width: 100%!important;
    box-sizing: border-box!important;
  }
  
  .option-btn {
    width: calc(100% - 32px)!important;
    max-width: 180px!important;
    height: 42px!important;
    font-size: 13px!important;
  }
}

.option-btn { 
  width: 180px!important; 
}
</style>